import React from 'react'
import { CommandButton } from '@fluentui/react/lib/Button';

function ToolBarDownFall(props) {

    //Parametros de entrada.
    const inputParam_ToolbarMenuProps = props.items;
    const inputParam_Display = props.display;
    const inputParam_Disabled = props.disabled === null || props.disabled === undefined ? false : props.disabled;
    const inputParam_MainItem = props.mainItem;
    const inputParam_MainItemText = props.mainItemText;
    

    //Parametros posibles a obtener como parametros de entrada.


    //Parametros de componente.


    //Funciones de componente.


    //Eventos de componente.


    //Render de componente.
    return (
        <>
            {
                inputParam_Display &&
                <CommandButton iconProps={ inputParam_MainItem } text={ inputParam_MainItemText } disabled={inputParam_Disabled} menuProps={ inputParam_ToolbarMenuProps } />
            }
            
        </>
    );
}

export default ToolBarDownFall;